import { useEffect, useState } from "react";

export default function useCountry() {
  const [countries, setCountries] = useState([]);
  const [error, setError] = useState("");

  async function fetchCountries() {
   
  }

  useEffect(() => {
    fetchCountries();
  }, []);

  return { countries, error };
}
